import { StyleSheet, I18nManager } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  button: {
    marginBottom: 46.5,
    marginLeft: I18nManager.isRTL ? 20 : 0,
    marginRight: I18nManager.isRTL ? 0 : 20,
    marginTop: 53,
  },
  container: {},
  stepImage: { width: 107, height: 107, position: 'absolute', right: -45 },
  descriptionContainer: { flexDirection: 'row' },
  text: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: 26,
    marginLeft: I18nManager.isRTL ? 86 : 0,
    marginRight: I18nManager.isRTL ? 0 : 86,
    marginTop: 4.1,
  },
});
